import { ApiConnectionData } from './api-connection-data';
import { SftpConnectionData } from './sftp-connection-data';

export type EdiConnectionDetails =
  | { type: 'api'; data: ApiConnectionData }
  | { type: 'sftp'; data: SftpConnectionData };
